import { Signup } from 'views/auth/signup/account';
import { SignupPlan } from 'views/auth/signup/plan';
import { SignupUser } from 'views/auth/signup/user';
import { SignupVerification } from 'views/auth/signup/verify';
import { Signin } from 'views/auth/signin';
import { SigninOTP } from 'views/auth/signin/otp';
import { SocialSignin } from 'views/auth/signin/social';
import { ForgotPassword } from 'views/auth/signin/forgotpassword';
import { ResetPassword } from 'views/auth/signin/resetpassword';
import { MagicSignin } from 'views/auth/signin/magic';
import { ImpersonateSignin } from 'views/auth/signin/impersonate';
import { MobileVerify } from 'views/auth/signup/mobileVerification';
import { LogoUpload } from 'views/auth/signup/logoUpload';
import { SigninMobileOTP } from 'views/auth/signin/signinMobileOTP';
import { StudentRegistration } from 'views/auth/signup/studentVerification';
import { MagicQuizSignin } from '../views/auth/signin/magicQuiz';
const Routes = [
  {
    path: '/signup',
    view: Signup,
    layout: 'auth',
    title: 'auth.signup.account.title'
  },
  {
    path: '/signup/verify',
    view: SignupVerification,
    layout: 'auth',
    title: 'auth.signup.verify.title'
  },
  {
    path: '/signup/mobile',
    view: MobileVerify,
    permission: 'signup.mobile.view',
    layout: 'auth',
    title: 'auth.signup.mobileVerification.title'
  },
  {
    path: '/signup/logo',
    view: LogoUpload,
    permission: 'signup.logo.view',
    layout: 'auth',
    hideNavItems: { contact: true },
    title: 'auth.signup.logoUpload.title'
  },
  {
    path: '/signup/plan',
    view: SignupPlan,
    layout: 'auth',
    permission: 'signup.plan.view',
    title: 'auth.signup.plan.title'
  },
  {
    path: '/signup/user',
    view: SignupUser,
    layout: 'auth',
    title: 'auth.signup.user.title',
    hideNavItems: { contact: true, signup: true, signin: true }
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: 'auth.signin.index.title'
  },
  {
    path: '/signin/otp',
    view: SigninOTP,
    layout: 'auth',
    title: 'auth.signin.otp.title'
  },
  {
    path: '/signin/social',
    view: SocialSignin,
    layout: 'auth',
    title: 'auth.signin.social.title'
  },
  {
    path: '/magic',
    view: MagicSignin,
    layout: 'auth',
    title: 'auth.signin.magic.title'
  },
  {
    path: '/quiz/magic',
    view: MagicQuizSignin,
    layout: 'auth',
    title: 'auth.signin.magic.title'
  },
  {
    path: '/forgotpassword',
    view: ForgotPassword,
    layout: 'auth',
    title: 'auth.signin.forgotpassword.title'
  },
  {
    path: '/resetpassword',
    view: ResetPassword,
    layout: 'auth',
    title: 'auth.signin.resetpassword.title'
  },
  {
    path: '/signin/impersonate',
    view: ImpersonateSignin,
    layout: 'auth',
    title: 'auth.signin.impersonate.title'
  },
  {
    path: '/signin/mobile',
    view: SigninMobileOTP,
    layout: 'auth',
    title: 'auth.signin.signinMobileOTP.title'
  },
  {
    path: '/signup/register-student',
    view: StudentRegistration,
    layout: 'appPlain',
    title: 'Register Student'
  }
]

export default Routes;
